const IN_APP_BROWSER_PATTERN =
  /(WebView|wv|FBAN|FBAV|FB_IAB|Instagram|Line\/|MicroMessenger|Twitter|LinkedInApp|Snapchat|Pinterest|TikTok|Messenger)/i;

const isStandalonePwa = () =>
  typeof window !== "undefined" &&
  (window.matchMedia?.("(display-mode: standalone)")?.matches ||
    window.navigator?.standalone === true);

export const isInAppBrowserOrWebView = () => {
  if (typeof window === "undefined") {
    return false;
  }

  if (isStandalonePwa()) {
    return false;
  }

  const userAgent = window.navigator?.userAgent || "";
  const hasReactNativeBridge = typeof window.ReactNativeWebView !== "undefined";

  return IN_APP_BROWSER_PATTERN.test(userAgent) || hasReactNativeBridge;
};

const buildAndroidIntentUrl = (url) => {
  try {
    const parsed = new URL(url);
    const scheme = parsed.protocol.replace(":", "");
    return `intent://${parsed.host}${parsed.pathname}${parsed.search}${parsed.hash}#Intent;scheme=${scheme};package=com.android.chrome;end`;
  } catch {
    return null;
  }
};

export const handleAuthRedirectClick = (event, url, onBeforeNavigate) => {
  onBeforeNavigate?.();

  if (!url || !isInAppBrowserOrWebView()) {
    return;
  }

  event.preventDefault();
  event.stopPropagation();

  const openedWindow = window.open(url, "_blank", "noopener,noreferrer");
  if (openedWindow) {
    openedWindow.opener = null;
    return;
  }

  const isAndroid = /Android/i.test(window.navigator?.userAgent || "");
  if (isAndroid) {
    const intentUrl = buildAndroidIntentUrl(url);
    if (intentUrl) {
      window.location.href = intentUrl;
      return;
    }
  }

  window.location.href = url;
};
